export const PaymentMethod = {
  pos_cash: 'pos_cash',
  doku_qris: 'doku-qris',
  duitnow: 'razer_duitnow_qr',
  union_experience_voucher: 'union_experience_voucher',
  PINE_LABS : 'pine-labs-pos-channel'
};

export enum LOCALSTORAGE_FTUE {
  QRIS_FTUE = 'qris_ftue',
  DUITNOW_FTUE = 'duitnow_ftue'
}

export enum PAYMENT_CHANNEL_ID{
  QRIS_CHANNEL_ID = 'qris',
  DUITNOW_CHANNEL_ID = 'RPP_DUITNOWQR'
}

export enum PAYMENT_GATEWAY{
  DOKU_GATEWAY = 'doku',
  RAZERPAY_GATEWAY = 'razerpay'
}

export enum PAYMENT_PROCESS{
  DIRECT = 'direct',
  CHECKOUT = 'checkout'
}

export enum PAYMENT_STATUS {
  UNPAID = '1', // nothing is paid
  PARTIALLY_PAID = '2', // Partial payment has been made, and a portion remains unpaid.
  PAID_WITH_ZERO_BALANCE = '3', // if total amount to be paid is equal to 0
  PAID_WITH_NEGATIVE_BALANCE = '4', // if total amount to be paid is less than 0
}

export enum PAYMENT_STATUS_NUM {
  UNPAID = 1, // nothing is paid
  PARTIALLY_PAID = 2, // Partial payment has been made, and a portion remains unpaid.
  PAID_WITH_ZERO_BALANCE = 3, // if total amount to be paid is equal to 0
  PAID_WITH_NEGATIVE_BALANCE = 4, // if total amount to be paid is less than 0
}
